'use strict';

/* ── MOBILE MENU ─────────────────────────────────────────────── */
const hamburger  = document.getElementById('hamburger');
const mobileMenu = document.getElementById('mobile-menu');
if (hamburger && mobileMenu) {
  function openMenu()  { mobileMenu.classList.replace('translate-x-full','translate-x-0'); hamburger.setAttribute('aria-expanded','true');  document.body.style.overflow='hidden'; }
  function closeMenu() { mobileMenu.classList.replace('translate-x-0','translate-x-full'); hamburger.setAttribute('aria-expanded','false'); document.body.style.overflow=''; }
  hamburger.addEventListener('click', () => hamburger.getAttribute('aria-expanded')==='true' ? closeMenu() : openMenu());
  document.querySelectorAll('.nav-mob').forEach(l => l.addEventListener('click', closeMenu));
}

/* ── NAV SCROLL ──────────────────────────────────────────────── */
const mainNav = document.getElementById('main-nav');
if (mainNav) window.addEventListener('scroll', () => mainNav.classList.toggle('nav-scrolled', window.scrollY > 50), { passive:true });

/* ── SCROLL SPY ──────────────────────────────────────────────── */
const spySections = Array.from(document.querySelectorAll('section[id],footer[id]'));
const navLinks    = Array.from(document.querySelectorAll('.nav-link'));
window.addEventListener('scroll', () => {
  let active = '';
  spySections.forEach(s => { if (window.scrollY >= s.offsetTop - 130) active = s.id; });
  navLinks.forEach(l => l.classList.toggle('active', l.getAttribute('href')?.endsWith('#' + active)));
}, { passive:true });

/* ── SCROLL REVEAL ───────────────────────────────────────────── */
const revealObs = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    const el = entry.target;
    setTimeout(() => el.classList.add('revealed'), parseInt(el.dataset.delay ?? 0));
    revealObs.unobserve(el);
  });
}, { threshold:0.12, rootMargin:'0px 0px -48px 0px' });
document.querySelectorAll('[data-reveal]').forEach(el => revealObs.observe(el));

/* ── HERO PARALLAX ───────────────────────────────────────────── */
const parallaxEl = document.getElementById('hero-parallax');
if (parallaxEl) {
  window.addEventListener('scroll', () => {
    if (window.scrollY < window.innerHeight)
      parallaxEl.style.transform = `translateY(${window.scrollY * 0.28}px)`;
  }, { passive:true });
}

/* ── TOAST ───────────────────────────────────────────────────── */
window.showToast = function(msg, type = 'success') {
  const el = document.getElementById('toast');
  if (!el) return;
  el.textContent = msg;
  el.className = 'show ' + type;
  clearTimeout(el._t);
  el._t = setTimeout(() => el.classList.remove('show'), 3200);
};

/* ── SHOPIFY CART ────────────────────────────────────────────── */
let cart = { items: [], item_count: 0, total_price: 0 };

async function fetchCart() {
  const res = await fetch('/cart.js');
  cart = await res.json();
  return cart;
}

async function addToCartByHandle(handle) {
  try {
    // Get variant ID from product JSON
    const res  = await fetch(`/products/${handle}.js`);
    if (!res.ok) { showToast('Product not found', 'error'); return; }
    const product = await res.json();
    const variantId = product.variants[0].id;

    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!addRes.ok) { showToast('Could not add to cart', 'error'); return; }
    await fetchCart();
    renderCart();
    updateBadge(cart.item_count);
    showToast(product.title + ' added to cart!', 'success');
    openCart();
  } catch (e) {
    showToast('Could not add to cart', 'error');
  }
}

async function changeCartItem(lineItemKey, quantity) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: lineItemKey, quantity })
  });
  await fetchCart();
  renderCart();
  updateBadge(cart.item_count);
}

window.updateCartItem = (key, qty) => changeCartItem(key, qty);
window.removeCartItem = (key)      => changeCartItem(key, 0);

/* ── CART BADGE ──────────────────────────────────────────────── */
function updateBadge(count) {
  const badge = document.getElementById('cart-count-badge');
  if (!badge) return;
  badge.textContent = count;
  badge.classList.toggle('visible', count > 0);
}

/* ── RENDER CART ─────────────────────────────────────────────── */
function renderCart() {
  const container   = document.getElementById('cart-items-container');
  const subtotalEl  = document.getElementById('cart-subtotal');
  const countEl     = document.getElementById('cart-header-count');
  const checkoutBtn = document.getElementById('checkout-btn');
  if (!container) return;

  const count = cart.item_count || 0;
  if (countEl) countEl.textContent = count + ' item' + (count !== 1 ? 's' : '');
  if (subtotalEl) subtotalEl.textContent = '$' + ((cart.total_price || 0) / 100).toFixed(2);
  if (checkoutBtn) {
    if (count > 0) { checkoutBtn.style.opacity='1'; checkoutBtn.style.pointerEvents='auto'; }
    else           { checkoutBtn.style.opacity='.4'; checkoutBtn.style.pointerEvents='none'; }
  }

  if (!cart.items || !cart.items.length) {
    container.innerHTML = `<div style="text-align:center;padding:48px 20px;">
      <div style="font-size:40px;margin-bottom:16px;">🛒</div>
      <p class="font-display" style="font-size:14px;letter-spacing:.1em;text-transform:uppercase;color:var(--text-3);">Your cart is empty</p>
      <p class="font-body" style="font-size:13px;color:var(--text-3);margin-top:6px;">Add some Dynalik to get started!</p>
    </div>`;
    return;
  }

  container.innerHTML = cart.items.map(item => {
    const imgUrl = item.featured_image?.url || '';
    const price  = (item.price / 100).toFixed(2);
    return `
    <div class="cart-item">
      <div class="cart-item-img">
        ${imgUrl ? `<img src="${imgUrl}" alt="${item.title}">` : '📦'}
      </div>
      <div style="flex:1;min-width:0;">
        <p class="font-display" style="font-size:13px;font-weight:600;text-transform:uppercase;letter-spacing:.06em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${item.product_title}</p>
        <p class="font-display" style="font-size:13px;color:var(--orange);font-weight:700;margin-top:2px;">$${price}</p>
      </div>
      <div style="display:flex;align-items:center;gap:8px;flex-shrink:0;">
        <button class="qty-btn" onclick="updateCartItem('${item.key}',${item.quantity - 1})">−</button>
        <span class="font-display" style="font-size:14px;font-weight:700;min-width:20px;text-align:center;">${item.quantity}</span>
        <button class="qty-btn" onclick="updateCartItem('${item.key}',${item.quantity + 1})">+</button>
        <button onclick="removeCartItem('${item.key}')" style="width:28px;height:28px;border-radius:6px;background:rgba(220,50,50,.1);border:1px solid rgba(220,50,50,.2);color:#ff8080;cursor:pointer;display:flex;align-items:center;justify-content:center;margin-left:4px;">
          <svg width="12" height="12" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>
    </div>`;
  }).join('');
}

/* ── OPEN / CLOSE CART ───────────────────────────────────────── */
window.openCart = function() {
  document.getElementById('cart-drawer')?.classList.add('open');
  document.getElementById('cart-overlay')?.classList.add('open');
  document.body.style.overflow = 'hidden';
};
window.closeCart = function() {
  document.getElementById('cart-drawer')?.classList.remove('open');
  document.getElementById('cart-overlay')?.classList.remove('open');
  document.body.style.overflow = '';
};

/* ── WIRE ADD TO CART BUTTONS ────────────────────────────────── */
document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
  btn.addEventListener('click', e => {
    e.stopPropagation();
    const card   = btn.closest('[data-product-handle]');
    const handle = card?.dataset.productHandle;
    if (handle) addToCartByHandle(handle);
  });
});

/* ── SHOP CARD CLICK → FLAVOR VIEWER ────────────────────────── */
const shopCards = document.querySelectorAll('.shop-card');
shopCards.forEach(card => {
  card.addEventListener('click', e => {
    if (e.target.classList.contains('add-to-cart-btn') || e.target.closest('.add-to-cart-btn')) return;
    const scene = card.dataset.scene;
    if (!scene || !window.flavors?.[scene]) return;
    document.getElementById('flavors')?.scrollIntoView({ behavior:'smooth' });
    setTimeout(() => {
      document.querySelectorAll('.flavor-btn').forEach(b => b.classList.remove('active'));
      const matchBtn = document.querySelector(`.flavor-btn[data-flavor="${scene}"]`);
      if (matchBtn) matchBtn.classList.add('active');
      if (window.renderFlavor) window.renderFlavor(scene);
    }, 600);
  });
});

/* ── SHOP TABS ───────────────────────────────────────────────── */
const shopTabs = document.querySelectorAll('.shop-tab');
shopTabs.forEach(tab => {
  tab.addEventListener('click', () => {
    shopTabs.forEach(t => t.classList.remove('active'));
    tab.classList.add('active');
    const filter = tab.dataset.tab;
    document.querySelectorAll('.shop-card').forEach(card => {
      const cats = (card.dataset.cat || '').split(' ');
      card.style.display = (filter === 'all' || cats.includes(filter)) ? '' : 'none';
    });
  });
});

/* ── SLIDESHOW ───────────────────────────────────────────────── */
(function() {
  const track = document.getElementById('product-slides');
  const dots  = document.querySelectorAll('.slideshow-dot');
  if (!track) return;
  let cur = 0, timer;
  const total = track.children.length;

  function goTo(n) {
    cur = (n + total) % total;
    track.style.transform = `translateX(-${cur * 100}%)`;
    dots.forEach((d, i) => d.classList.toggle('active', i === cur));
  }
  function next() { goTo(cur + 1); }
  function resetTimer() { clearInterval(timer); timer = setInterval(next, 5000); }

  document.getElementById('slide-next')?.addEventListener('click', () => { next(); resetTimer(); });
  document.getElementById('slide-prev')?.addEventListener('click', () => { goTo(cur - 1); resetTimer(); });
  dots.forEach(d => d.addEventListener('click', () => { goTo(parseInt(d.dataset.idx)); resetTimer(); }));
  timer = setInterval(next, 5000);
})();

/* ── FLAVOR DATA ─────────────────────────────────────────────── */
window.flavors = {
  apple:     { tag:'Apple', name:'Dynalik Apple', desc:'The classic deer favorite. Our Apple formula delivers a crisp, sweet scent that travels far and triggers an immediate response. Works exceptionally well during early season and pre-rut when deer are actively seeking high-sugar food sources.', notes:['Sweet & crisp scent profile','High-sugar aroma triggers feeding response','Ideal for early season through rut'] },
  persimmon: { tag:'Persimmon', name:'Dynalik Persimmon', desc:'Persimmon is one of the most natural and irresistible scents to whitetail deer. Our Persimmon formula mimics the ripe fruit deer seek out in fall — making it deadly effective during the pre-rut and rut periods.', notes:['Natural whitetail favorite','Peak effectiveness during pre-rut & rut','Deep, musky-sweet aroma deer can\'t resist'] },
  peanut:    { tag:'Sweetened Peanut Butter', name:'Dynalik Peanut Butter', desc:'Our Sweetened Peanut Butter flavor has a rich, lingering aroma that deer investigate from extraordinary distances. The combination of sweet and savory creates a unique scent that keeps deer on the site for extended periods.', notes:['Extraordinary scent throw distance','Rich aroma holds deer at the site longer','Unique sweet-savory combo deer love'] },
  cherry:    { tag:'Wild Cherry', name:'Dynalik Wild Cherry', desc:'Bold, bright, and irresistible. Wild Cherry gives off a sharp fruity scent that cuts through thick cover and reaches deer far downwind. It\'s a go-to flavor for hunters who want aggressive draw power season-long.', notes:['Sharp scent cuts through thick cover','Aggressive draw power all season','Works on both bucks and does'] },
  dirt:      { tag:'DynaDIRT', name:'DynaDIRT Mineral', desc:'Earth-based mineral attractant that creates natural-looking deer wallows and scrape sites. DynaDIRT works with the soil so deer return to the same spot again and again — building consistent trail camera and stand opportunities.', notes:['Creates natural wallow & scrape sites','Deer revisit the same location repeatedly','Works with existing soil for maximum effect'] },
};

const A = window.DYNALIK?.assets || {};
// Use String.fromCodePoint so emoji survive any encoding layer
const E = {
  apple:      String.fromCodePoint(0x1F34E), // 🍎
  appleG:     String.fromCodePoint(0x1F34F), // 🍏
  cherry:     String.fromCodePoint(0x1F352), // 🍒
  blossom:    String.fromCodePoint(0x1F338), // 🌸
  leaf:       String.fromCodePoint(0x1F342), // 🍂
  maple:      String.fromCodePoint(0x1F341), // 🍁
  herb:       String.fromCodePoint(0x1F33F), // 🌿
  seedling:   String.fromCodePoint(0x1F331), // 🌱
  peanut:     String.fromCodePoint(0x1F95C), // 🥜
  wheat:      String.fromCodePoint(0x1F33E), // 🌾
  orange:     String.fromCodePoint(0x1F7E0), // 🟠
  heart:      String.fromCodePoint(0x2764),  // ❤
  star:       String.fromCodePoint(0x2B50),  // ⭐
  sparkle:    String.fromCodePoint(0x2728),  // ✨
};
const photoFlavors = {
  apple:     { img: A.apple,     bg:'radial-gradient(ellipse 80% 90% at 50% 50%,#1a3d20 0%,#0a1a0c 100%)', vignetteColor:'#0a1a0c', particles:[E.apple,E.appleG,E.herb,E.leaf,E.apple,E.sparkle], particleCount:22 },
  persimmon: { img: A.persimmon, bg:'radial-gradient(ellipse 80% 90% at 50% 50%,#4a2000 0%,#1a0a00 100%)', vignetteColor:'#1a0a00', particles:[E.orange,E.leaf,E.maple,E.orange,E.leaf,E.sparkle], particleCount:22 },
  cherry:    { img: A.cherry,    bg:'radial-gradient(ellipse 80% 90% at 50% 50%,#3d0a0a 0%,#160404 100%)', vignetteColor:'#160404', particles:[E.cherry,E.blossom,E.cherry,E.heart,E.cherry,E.sparkle], particleCount:22 },
  peanut:    { img: A.peanut,    bg:'radial-gradient(ellipse 80% 90% at 50% 50%,#3d2200 0%,#1a0e00 100%)', vignetteColor:'#1a0e00', particles:[E.peanut,E.leaf,E.peanut,E.wheat,E.peanut,E.sparkle], particleCount:22 },
  dirt:      { img: A.dirt,      bg:'radial-gradient(ellipse 80% 90% at 50% 50%,#2a1800 0%,#0f0a00 100%)', vignetteColor:'#0f0a00', particles:[E.seedling,E.leaf,E.seedling,E.wheat,E.sparkle,E.leaf],  particleCount:22 },
};

const bgRemovedCache = {};
function removeWhiteBg(src, callback) {
  if (bgRemovedCache[src]) { callback(bgRemovedCache[src]); return; }
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = function() {
    const cvs = document.createElement('canvas');
    const W = img.naturalWidth, H = img.naturalHeight;
    cvs.width = W; cvs.height = H;
    const ctx = cvs.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, W, H);
    ctx.drawImage(img, 0, 0);
    const imgData = ctx.getImageData(0, 0, W, H);
    const px = imgData.data;
    const THRESH = 253;
    function isWhite(n) { const i=n*4; return px[i]>=THRESH&&px[i+1]>=THRESH&&px[i+2]>=THRESH; }
    const isBg = new Uint8Array(W*H), queue = [];
    function seed(x,y) { const n=y*W+x; if(!isBg[n]&&isWhite(n)){isBg[n]=1;queue.push(n);} }
    for(let x=0;x<W;x++){seed(x,0);seed(x,H-1);}
    for(let y=0;y<H;y++){seed(0,y);seed(W-1,y);}
    let qi=0;
    while(qi<queue.length){const n=queue[qi++],x=n%W,y=(n/W)|0;if(x>0&&!isBg[n-1]&&isWhite(n-1)){isBg[n-1]=1;queue.push(n-1);}if(x<W-1&&!isBg[n+1]&&isWhite(n+1)){isBg[n+1]=1;queue.push(n+1);}if(y>0&&!isBg[n-W]&&isWhite(n-W)){isBg[n-W]=1;queue.push(n-W);}if(y<H-1&&!isBg[n+W]&&isWhite(n+W)){isBg[n+W]=1;queue.push(n+W);}}
    const alpha=new Float32Array(W*H);
    for(let n=0;n<W*H;n++) alpha[n]=isBg[n]?0:255;
    const BLUR=7,tmp=new Float32Array(W*H);
    for(let y=0;y<H;y++){let s=0;for(let x=0;x<=BLUR*2;x++)s+=alpha[y*W+Math.min(x,W-1)];for(let x=0;x<W;x++){tmp[y*W+x]=s/(BLUR*2+1);if(x-BLUR>=0)s-=alpha[y*W+(x-BLUR)];if(x+BLUR+1<W)s+=alpha[y*W+(x+BLUR+1)];}}
    const blurred=new Float32Array(W*H);
    for(let x=0;x<W;x++){let s=0;for(let y=0;y<=BLUR*2;y++)s+=tmp[Math.min(y,H-1)*W+x];for(let y=0;y<H;y++){blurred[y*W+x]=s/(BLUR*2+1);if(y-BLUR>=0)s-=tmp[(y-BLUR)*W+x];if(y+BLUR+1<H)s+=tmp[(y+BLUR+1)*W+x];}}
    for(let n=0;n<W*H;n++) px[n*4+3]=Math.round(blurred[n]);
    ctx.putImageData(imgData,0,0);
    cvs.toBlob(blob=>{const url=URL.createObjectURL(blob);bgRemovedCache[src]=url;callback(url);},'image/png');
  };
  img.onerror = () => callback(src);
  img.src = src;
}

function spawnParticles(overlay, particleList, count) {
  overlay.querySelectorAll('.fruit-particle').forEach(el => el.remove());
  for(let i=0;i<count;i++){
    const el=document.createElement('span');
    el.className='fruit-particle';
    el.textContent=particleList[Math.floor(Math.random()*particleList.length)];
    const size=1.1+Math.random()*1.4,dur=4+Math.random()*6,delay=-Math.random()*9,anim=Math.random()>.5?'fallFruit':'driftFruit';
    el.style.cssText=`left:${Math.random()*100}%;top:0;font-size:${size}rem;animation:${anim} ${dur}s ${delay}s ease-in infinite;opacity:0;`;
    overlay.appendChild(el);
  }
}

/* ── FLAVOR SWITCHER ─────────────────────────────────────────── */
const flavorTag     = document.getElementById('flavor-tag');
const flavorName    = document.getElementById('flavor-name');
const flavorContent = document.getElementById('flavor-content');
const flavorBtns    = document.querySelectorAll('.flavor-btn');
const photoOverlay  = document.getElementById('flavor-photo-overlay');
const productImg    = document.getElementById('flavor-product-img');
const canvasHint    = document.getElementById('canvas-hint');
const flavorCanvas  = document.getElementById('flavor-canvas');

let currentFlavorKey = 'apple';
const FLAVOR_TO_HANDLE = {
  apple:'apple-single', cherry:'cherry-single', persimmon:'persimmon-single',
  peanut:'peanut-butter-single', dirt:'dirt-single',
};

window.renderFlavor = function(key) {
  currentFlavorKey = key;
  const f = window.flavors[key];
  if (!f) return;
  if (flavorTag)  flavorTag.textContent  = f.tag;
  if (flavorName) flavorName.textContent = f.name;
  if (flavorContent) flavorContent.innerHTML = `
    <p class="font-body text-drift leading-[1.75] mb-6">${f.desc}</p>
    <ul class="space-y-3">${f.notes.map(n=>`<li class="flex items-start gap-3"><span class="w-1.5 h-1.5 rounded-full bg-cr-orange flex-shrink-0 mt-2"></span><span class="font-body text-sm text-drift/80 leading-relaxed">${n}</span></li>`).join('')}</ul>`;

  const photo = photoFlavors[key];
  if (photo && photo.img) {
    if (flavorCanvas) flavorCanvas.style.opacity = '0';
    photoOverlay.style.background = photo.bg;
    const vignette = document.getElementById('flavor-vignette');
    if (vignette) vignette.style.setProperty('--vignette-color', photo.vignetteColor || '#0a0a0a');
    if (productImg) {
      productImg.alt = f.name; productImg.src = '';
      const capturedKey = key;
      removeWhiteBg(photo.img, url => { if (currentFlavorKey === capturedKey) productImg.src = url; });
    }
    photoOverlay.querySelectorAll('.fruit-particle').forEach(el => el.remove());
    spawnParticles(photoOverlay, photo.particles, photo.particleCount);
    photoOverlay.classList.add('active');
    if (canvasHint) canvasHint.style.opacity = '0';
  } else {
    photoOverlay.classList.remove('active');
    photoOverlay.querySelectorAll('.fruit-particle').forEach(el => el.remove());
    if (canvasHint) canvasHint.style.opacity = '';
    if (flavorCanvas) flavorCanvas.style.opacity = '';
    if (window.switchFlavorScene) window.switchFlavorScene(key);
  }
};

flavorBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    flavorBtns.forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    window.renderFlavor(btn.dataset.flavor);
    window.setCurrentFlavor && window.setCurrentFlavor(btn.dataset.flavor);
  });
});

window.flavorAddToCart = function() {
  const handle = FLAVOR_TO_HANDLE[currentFlavorKey];
  if (handle) addToCartByHandle(handle);
};

/* ── SHOP CARD 3D BAG IMAGES ─────────────────────────────────── */
const cardImageMap = {
  apple: A.apple, cherry: A.cherry, persimmon: A.persimmon, peanut: A.peanut,
  dirt: A.dirt,
};
document.querySelectorAll('.shop-card').forEach(card => {
  const scene  = card.dataset.scene;
  const imgSrc = cardImageMap[scene];
  if (!imgSrc) return;
  const p6 = card.querySelector('.p-6');
  if (!p6) return;
  const scene3d = document.createElement('div'); scene3d.className = 'bag-3d-scene';
  const inner = document.createElement('div'); inner.className = 'bag-3d-inner';
  const img = document.createElement('img'); img.alt = '';
  const light = document.createElement('div'); light.className = 'bag-3d-light';
  const glare = document.createElement('div'); glare.className = 'bag-3d-glare';
  const groundShadow = document.createElement('div'); groundShadow.className = 'bag-3d-shadow';
  inner.appendChild(img); inner.appendChild(light); inner.appendChild(glare);
  scene3d.appendChild(groundShadow); scene3d.appendChild(inner);
  p6.insertBefore(scene3d, p6.firstChild);
  removeWhiteBg(imgSrc, url => { img.src = url; });
  scene3d.addEventListener('mousemove', e => {
    const r = scene3d.getBoundingClientRect();
    const x=(e.clientX-r.left)/r.width, y=(e.clientY-r.top)/r.height;
    const cx=x-.5, cy=y-.5;
    inner.style.transition='transform 0.08s ease-out';
    inner.style.transform=`rotateY(${cx*14}deg) rotateX(${-cy*10}deg) scale(1.04) translateY(-3px)`;
    const shX=-cx*16, shY=Math.abs(cy)*8+18;
    img.style.filter=`drop-shadow(${shX}px ${shY}px 28px rgba(0,0,0,.90)) drop-shadow(${shX*.3}px ${shY*.4}px 10px rgba(0,0,0,.55)) drop-shadow(0 2px 5px rgba(0,0,0,.40))`;
    const lx=(1-x)*100, ly=(1-y)*100;
    light.style.background=`radial-gradient(ellipse 50% 55% at ${lx}% ${ly}%,rgba(255,255,255,.22) 0%,transparent 65%),linear-gradient(${135+cx*30}deg,transparent 35%,rgba(0,0,0,.22) 100%)`;
    glare.style.background=`radial-gradient(circle 28px at ${x*100}% ${y*100}%,rgba(255,255,255,.55),transparent 70%)`;
    glare.style.opacity='1';
    groundShadow.style.width=`${60+Math.abs(cx)*20}px`;
    groundShadow.style.transform=`translateX(calc(-50% + ${cx*12}px))`;
  });
  scene3d.addEventListener('mouseleave', () => {
    inner.style.transition='transform 0.55s cubic-bezier(0.34,1.56,0.64,1)';
    inner.style.transform='';
    img.style.filter='';
    light.style.background='';
    glare.style.opacity='0';
    groundShadow.style.width='72px';
    groundShadow.style.transform='translateX(-50%)';
  });
});

/* ── THREE.JS FLAVOR CANVAS ──────────────────────────────────── */
(function() {
  const canvas = document.getElementById('flavor-canvas');
  if (!canvas || typeof THREE === 'undefined') return;

  const renderer = new THREE.WebGLRenderer({ canvas, antialias:true, alpha:true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setSize(canvas.clientWidth, canvas.clientHeight, false);
  renderer.shadowMap.enabled = true;

  const scene  = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(45, canvas.clientWidth / canvas.clientHeight, 0.1, 100);
  camera.position.set(0, 0, 4.2);

  // Lights
  scene.add(new THREE.AmbientLight(0xffffff, 0.6));
  const dir = new THREE.DirectionalLight(0xffffff, 1.2); dir.position.set(3,5,4); scene.add(dir);
  const fill = new THREE.PointLight(0x4488ff, 0.4, 20); fill.position.set(-4,-2,-3); scene.add(fill);

  // Particle system
  const particleGeo = new THREE.BufferGeometry();
  const PCount = 180;
  const positions = new Float32Array(PCount * 3);
  const velocities = new Float32Array(PCount * 3);
  for(let i=0;i<PCount;i++){
    positions[i*3]=(Math.random()-.5)*8;
    positions[i*3+1]=(Math.random()-.5)*6;
    positions[i*3+2]=(Math.random()-.5)*4;
    velocities[i*3]=(Math.random()-.5)*.004;
    velocities[i*3+1]=(Math.random()-.5)*.006;
    velocities[i*3+2]=(Math.random()-.5)*.002;
  }
  particleGeo.setAttribute('position', new THREE.BufferAttribute(positions, 3));
  const particleMat = new THREE.PointsMaterial({ color:0xE85C0D, size:0.025, transparent:true, opacity:0.6 });
  const particles = new THREE.Points(particleGeo, particleMat);
  scene.add(particles);

  // Bag mesh (rounded box standing upright)
  const bagGeo = new THREE.BoxGeometry(1.6, 2.4, 0.45, 2, 2, 2);
  const bagMat = new THREE.MeshStandardMaterial({ color:0x2a6230, roughness:0.35, metalness:0.05 });
  const bag = new THREE.Mesh(bagGeo, bagMat);
  scene.add(bag);

  // Logo plane on front of bag
  const logoGeo = new THREE.PlaneGeometry(1.2, 0.5);
  const logoMat = new THREE.MeshStandardMaterial({ color:0xffffff, roughness:0.8 });
  const logo = new THREE.Mesh(logoGeo, logoMat);
  logo.position.set(0, 0.3, 0.23);
  bag.add(logo);

  // Color map per flavor scene
  const sceneColors = {
    apple:'#1a3d1b', cherry:'#3d0a0a', persimmon:'#4a2000', peanut:'#3d2200', dirt:'#2a1800',
  };

  window.switchFlavorScene = function(key) {
    const col = sceneColors[key] || '#286230';
    bagMat.color.set(col);
    particleMat.color.set(key === 'cherry' ? 0xff2244 : key === 'apple' ? 0x44cc44 : key === 'persimmon' ? 0xE87820 : key === 'peanut' ? 0xcc8822 : 0xE85C0D);
  };

  // Mouse drag rotation
  let isDragging=false, prevX=0, prevY=0, rotX=0, rotY=0;
  canvas.addEventListener('mousedown', e=>{isDragging=true;prevX=e.clientX;prevY=e.clientY;canvas.style.cursor='grabbing';});
  window.addEventListener('mouseup', ()=>{isDragging=false;canvas.style.cursor='grab';});
  window.addEventListener('mousemove', e=>{if(!isDragging)return;rotY+=(e.clientX-prevX)*.008;rotX+=(e.clientY-prevY)*.008;rotX=Math.max(-1,Math.min(1,rotX));prevX=e.clientX;prevY=e.clientY;});
  canvas.addEventListener('touchstart', e=>{prevX=e.touches[0].clientX;prevY=e.touches[0].clientY;},{passive:true});
  canvas.addEventListener('touchmove', e=>{rotY+=(e.touches[0].clientX-prevX)*.006;rotX+=(e.touches[0].clientY-prevY)*.006;rotX=Math.max(-1,Math.min(1,rotX));prevX=e.touches[0].clientX;prevY=e.touches[0].clientY;},{passive:true});

  // Resize
  const ro = new ResizeObserver(()=>{
    renderer.setSize(canvas.clientWidth, canvas.clientHeight, false);
    camera.aspect = canvas.clientWidth/canvas.clientHeight;
    camera.updateProjectionMatrix();
  });
  ro.observe(canvas);

  let t=0;
  function animate() {
    requestAnimationFrame(animate);
    t += 0.012;
    bag.rotation.y = rotY + Math.sin(t*.6)*.08;
    bag.rotation.x = rotX + Math.sin(t*.4)*.04;
    bag.position.y = Math.sin(t*.5)*.06;
    // Update particles
    const pos = particleGeo.attributes.position.array;
    for(let i=0;i<PCount;i++){
      pos[i*3]+=velocities[i*3]; pos[i*3+1]+=velocities[i*3+1]; pos[i*3+2]+=velocities[i*3+2];
      if(Math.abs(pos[i*3])>4) velocities[i*3]*=-1;
      if(Math.abs(pos[i*3+1])>3) velocities[i*3+1]*=-1;
      if(Math.abs(pos[i*3+2])>2) velocities[i*3+2]*=-1;
    }
    particleGeo.attributes.position.needsUpdate = true;
    renderer.render(scene, camera);
  }
  animate();
})();

/* ── FLAVOR FLAVOR BUTTON TRACKING ──────────────────────────── */
window.setCurrentFlavor = function(key) { currentFlavorKey = key; };

/* ── CTA FLAVOR BUTTONS ──────────────────────────────────────── */
document.querySelectorAll('.order-flavor-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.order-flavor-btn').forEach(b => b.classList.remove('border-cr-orange','text-cr-orange'));
    btn.classList.add('border-cr-orange','text-cr-orange');
  });
});

/* ── BOOT ────────────────────────────────────────────────────── */
(async function boot() {
  await fetchCart();
  renderCart();
  updateBadge(cart.item_count);
  window.renderFlavor('apple');
})();
